import { CONTAINER_BREAKPOINTS } from '@/constants/breakpoints';
import { ContainerBreakpointsType } from '@/constants/common';

import { useBreakpointQuery } from './useBreakpointQuery';

export const useAbove = (bp: ContainerBreakpointsType, ssrDefault = true) =>
  useBreakpointQuery(`(min-width: ${CONTAINER_BREAKPOINTS[bp]})`, ssrDefault);
